import React, { Fragment, useEffect, useState } from 'react';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';
import ScannerIcon from "@material-ui/icons/Scanner";

import {
    useStylesUp, useStylesHed, useStylesAuto, useStylesAutoPurch, useStylesTF, useStylesTD, useStylesBA, useStylesLbl
    , useStylesUiElemment,
    useStylesSpDial,
} from '../../../../St/Reports/UseStyle';
import { AppBar, Button, colors, Container, CssBaseline, Hidden, Paper, Toolbar } from '@material-ui/core';
import { useTranslation } from "react-i18next";
import KeyboardReturnSharpIcon from "@material-ui/icons/KeyboardReturnSharp";
import DeleteIcon from '@material-ui/icons/Delete';
import SearchIcon from '@material-ui/icons/Search';
import SaveIcon from '@material-ui/icons/Save';
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import CircularProgress from "@material-ui/core/CircularProgress";
import { insh } from "../../../../Context/InshSt";
import PrintIcon from "@material-ui/icons/Print";
import TransformIcon from "@material-ui/icons/Transform";
import Tab from "@material-ui/core/Tab";
import Fab from "@material-ui/core/Fab";
import Tooltip from "@material-ui/core/Tooltip";
import CheckIcon from "@material-ui/icons/Check";
import {
    ArrowDownward,
    Delete,
    MoreVert,
    PersonAddRounded,
    RestaurantMenu,
    Update,
} from "@material-ui/icons";
import Switch from "@material-ui/core/Switch";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import PostAddIcon from "@material-ui/icons/PostAdd";
import AddBoxIcon from "@material-ui/icons/AddBox";
import StopIcon from "@material-ui/icons/Stop";
import { StyledMenu, StyledMenuItem } from '../../../../St/comps/UseStyle';
import { openDrawer } from '../components/printSerivce';

export default function RestAppBar(props) {
    const { t } = useTranslation(["forms", "translation"]);

    const {
        AutoOptions,
        idata,
        backHome,
        handOpenDw,
        isHedden,
        permistionInv,
        style,
        stElemnt,
        clasBA,
        transForm,
        handOpenDwt,
        handNewInv,
        TransitionDown,
        styBtn,
        toWhere,
        loading,
        buttonClassnameSave,
        success,
        clasCAB,
        or,
        buttonClassnamePrint,
        clickCloseToggle,
        toPrint,
        toggle,
        isOpenUpdate,
        elmntBtn,
        clickUpdate,
        generating,
        toPrintCashOrNetwork,
        valueType,
        transformDone,
        stor,
        sendToZatca,
        elmntIcon,
        clickOpenToggle,
        deleteTos,
        uiElement,
        buttonClassnameDelete,
        isSavingRef
    } = props;
    const clasup = useStylesUp();
    const [styles, setStyles] = useState(insh.bascData);
    let isSave = permistionInv?.ISSAVE == null ? true : permistionInv?.ISSAVE;

    const calsPurch = useStylesAutoPurch();
    const claslbl = useStylesLbl();
    const clasAo = useStylesAuto();
    const clasTF = useStylesTF();
    return (
        <React.Fragment>
            <CssBaseline />
            <AppBar
                position="fixed"
                color="primary"
                style={{ ...style.bgImg, ...stElemnt.all.appBarBA, direction: "ltr" }}
            >
                <Toolbar className={clasBA.ToolbarBA} variant="dense">
                    <Hidden smUp={["sm"]}>
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="backH"
                            onClick={backHome}
                        >
                            <CloseIcon />
                        </IconButton>
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="searsh"
                            disabled={!permistionInv.Se}
                            onClick={() => handOpenDwt(TransitionDown)}
                        >
                            <StopIcon />
                        </IconButton>
                        <IconButton
                            edge="start"
                            color="inherit"
                            aria-label="searsh"
                            disabled={!permistionInv.Se}
                            onClick={() => handOpenDw(TransitionDown)}
                        >
                            <SearchIcon />
                        </IconButton>

                        <IconButton
                            edge="start"
                            color="inherit"
                            disabled={!permistionInv.Ne}
                            aria-label="handNew"
                            onClick={handNewInv}
                        >
                            <AddBoxIcon />
                        </IconButton>
                    </Hidden>

                    <Hidden only={["xs"]}>
                        <Button
                            style={styBtn.undis}
                            onClick={backHome}
                            startIcon={<CloseIcon />}
                        >
                            خروج
                        </Button>
                        {/* <Button
                            style={!permistionInv.Se ? styBtn.dis : styBtn.undis}
                            disabled={!permistionInv.Se}
                            onClick={() => handOpenDwt(TransitionDown)}
                            startIcon={<StopIcon />}
                        >
                            {transForm("out-billing")}
                        </Button> */}
                        {/* <Button
                            style={!permistionInv.Se ? styBtn.dis : styBtn.undis}
                            disabled={!permistionInv.Se}
                            onClick={() => handOpenDw(TransitionDown)}
                            startIcon={<SearchIcon />}
                        >
                            {transForm("invoice-search")}
                        </Button> */}
                        <Button
                            style={!permistionInv.Ne ? styBtn.dis : styBtn.undis}
                            disabled={!permistionInv.Ne}
                            onClick={handNewInv}
                            startIcon={<AddBoxIcon />}
                        >
                            {transForm("new")}
                        </Button>
                    </Hidden>
                    {/* <Button color="primary">Primary</Button> */}

                    <div className={clasBA.growBA} />

                    <StyledMenu
                        id="customized-menu"
                        anchorEl={toggle}
                        keepMounted
                        open={Boolean(toggle)}
                        onClose={clickCloseToggle}
                        style={stElemnt.itemHigh}
                    >
                        <div className={clasCAB.wrapperCAB}>
                            <StyledMenuItem
                                disabled={loading.print || loading.save || isSavingRef.current}
                                className={buttonClassnamePrint}
                                onClick={() => toPrint("print", "e", 1)}
                            >
                                <ListItemIcon>
                                    <PrintIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={transForm("cashier-view")} />
                            </StyledMenuItem>
                            {(loading.print || loading.save || isSavingRef.current) && (
                                <CircularProgress
                                    size={24}
                                    className={clasCAB.buttonProgressCAB}
                                />
                            )}
                        </div>

                        <div className={clasCAB.wrapperCAB}>
                            <StyledMenuItem
                                disabled={loading.print || loading.save || isSavingRef.current}
                                className={buttonClassnamePrint}
                                onClick={() => toPrint("print", "e", 2)}
                            >
                                <ListItemIcon>
                                    <ScannerIcon fontSize="small" />
                                </ListItemIcon>
                                <ListItemText primary={transForm("great-view")} />
                            </StyledMenuItem>
                            {(loading.print || loading.save || isSavingRef.current) && (
                                <CircularProgress
                                    size={24}
                                    className={clasCAB.buttonProgressCAB}
                                />
                            )}
                        </div>
                    </StyledMenu>

                    <Hidden smUp={["sm"]}>
                        {uiElement.DeleIcon === true ? (
                            <div className={clasCAB.wrapperCAB}>
                                {permistionInv.De ? (
                                    <Fab
                                        size="medium"
                                        color="primary"
                                        disabled
                                        style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                        className={buttonClassnameDelete}
                                        onClick={deleteTos}
                                    >
                                        {success.delete ? <CheckIcon /> : <DeleteIcon />}
                                    </Fab>
                                ) : (
                                    <Fragment>{elmntIcon(<DeleteIcon />, true)}</Fragment>
                                )}
                                {loading.delete && (
                                    <CircularProgress
                                        size={56}
                                        className={clasCAB.fabProgressCAB}
                                    />
                                )}
                            </div>
                        ) : null}

                        <div className={clasCAB.wrapperCAB}>
                            {permistionInv.Prv && permistionInv.SaUp ? (
                                <Fab
                                    size="medium"
                                    color="primary"
                                    style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                    onClick={clickOpenToggle}
                                >
                                    <PrintIcon />
                                </Fab>
                            ) : (
                                <Fragment>{elmntIcon(<PrintIcon />, true)}</Fragment>
                            )}
                        </div>

                        <div className={clasCAB.wrapperCAB}>
                            {permistionInv.SaUp ? (
                                <Fab
                                    size="medium"
                                    color="primary"
                                    disabled={
                                        or.postput == "toPost"
                                            ? false
                                            : loading.print || loading.save
                                    }
                                    style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                    className={buttonClassnameSave}
                                    onClick={() => toWhere("save", "e")}
                                >
                                    {" "}
                                    {success.save ? <CheckIcon /> : <SaveIcon />}
                                </Fab>
                            ) : (
                                <Fragment>{elmntIcon(<SaveIcon />, true)}</Fragment>
                            )}
                            {(loading.print || loading.save || isSavingRef.current) && (
                                <CircularProgress
                                    size={56}
                                    className={clasCAB.fabProgressCAB}
                                />
                            )}
                        </div>

                        {stor.invsType == 2 && or.postput != "toPost" ? (
                            <div className={clasCAB.wrapperCAB}>
                                <Fab
                                    size="medium"
                                    color="primary"
                                    style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                    onClick={transformDone}
                                >
                                    {" "}
                                    <TransformIcon />
                                </Fab>
                            </div>
                        ) : null}
                    </Hidden>

                    <Hidden only={["xs"]}>
                        {
                            (idata.ProcType_InvProc == "02" || idata.ProcType_InvProc == "12") &&
                            !idata?.IsReportedToZatca && or.postput == "toPut" && AutoOptions?.StepTwo?.id === 1 && (
                                <div className={clasCAB.wrapperCAB}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        startIcon={<TransformIcon />}
                                        style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                        onClick={() => sendToZatca("save")}
                                    >
                                        {"Submit To Zatca "}
                                    </Button>
                                </div>
                            )
                        }
                        {stor.invsType == 2 && or.postput != "toPost" ? (
                            <div className={clasCAB.wrapperCAB}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    startIcon={<TransformIcon />}
                                    style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                    onClick={transformDone}
                                >
                                    تحويل لفاتورة مبيعات
                                </Button>
                            </div>
                        ) : null}
                        <Hidden smDown>
                            <div className={clasCAB.wrapperCAB}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    // startIcon={<Drawer />}
                                    style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                    onClick={() => openDrawer()}
                                >
                                    {"Alt+Z"} {transForm("الدرج")}
                                </Button>
                            </div>
                        </Hidden>
                        {permistionInv.Prv && permistionInv.SaUp ? (
                            <Fragment>

                                {valueType.id == 2 && AutoOptions?.permType?.id === 3 && (
                                    <>
                                        <div className={clasCAB.wrapperCAB}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="large"
                                                className={buttonClassnamePrint}
                                                startIcon={<PrintIcon />}
                                                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                                disabled={loading.print || loading.save || isSavingRef.current}
                                                onClick={() => toPrintCashOrNetwork("print", "e", 1, true)}
                                            >
                                                {transForm("شبكة")}
                                            </Button>
                                            {(loading.print || loading.save || generating) && (
                                                <CircularProgress
                                                    size={24}
                                                    className={clasCAB.buttonProgressCAB}
                                                />
                                            )}
                                        </div>
                                        <div className={clasCAB.wrapperCAB}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="large"
                                                className={buttonClassnamePrint}
                                                startIcon={<PrintIcon />}
                                                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                                disabled={loading.print || loading.save || isSavingRef.current}
                                                onClick={() => toPrintCashOrNetwork("print", "e", 1, false)}
                                            >
                                                {transForm("كاش")}
                                            </Button>
                                            {(loading.print || loading.save || isSavingRef.current) && (
                                                <CircularProgress
                                                    size={24}
                                                    className={clasCAB.buttonProgressCAB}
                                                />
                                            )}
                                        </div>
                                    </>
                                )}

                                {AutoOptions?.permType?.id === 7 &&
                                    (

                                        <div className={clasCAB.wrapperCAB}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="large"
                                                className={buttonClassnamePrint}
                                                startIcon={<PrintIcon />}
                                                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                                disabled={loading.print || loading.save || isSavingRef.current}
                                                onClick={() => toPrint("print", "e", 3)}
                                            >
                                                {transForm("cashier-view")}
                                            </Button>
                                            {(loading.print || loading.save || isSavingRef.current) && (
                                                <CircularProgress
                                                    size={24}
                                                    className={clasCAB.buttonProgressCAB}
                                                />
                                            )}
                                        </div>
                                    )}
                                <div className={clasCAB.wrapperCAB}>
                                    <Button
                                        variant="contained"
                                        color="primary"
                                        size="large"
                                        className={buttonClassnamePrint}
                                        startIcon={<ScannerIcon />}
                                        style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                        disabled={loading.print || loading.save || isSavingRef.current}
                                        onClick={() => toPrint("print", "e", 2)}
                                    >
                                        {transForm("great-view")}
                                    </Button>
                                    {(loading.print || loading.save || isSavingRef.current) && (
                                        <CircularProgress
                                            size={24}
                                            className={clasCAB.buttonProgressCAB}
                                        />
                                    )}
                                </div>
                                {AutoOptions?.permType?.id !== 7 &&
                                    (
                                        <div className={clasCAB.wrapperCAB}>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                size="large"
                                                className={buttonClassnamePrint}
                                                startIcon={<PrintIcon />}
                                                style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                                disabled={loading.print || loading.save || isSavingRef.current}
                                                onClick={() => toPrint("print", "e", 1)}
                                            >
                                                {transForm("cashier-view")}
                                            </Button>
                                            {(loading.print || loading.save || isSavingRef.current) && (
                                                <CircularProgress
                                                    size={24}
                                                    className={clasCAB.buttonProgressCAB}
                                                />
                                            )}
                                        </div>
                                    )}

                            </Fragment>
                        ) : (
                            <Fragment>
                                {elmntBtn("معاينة كبير", <ScannerIcon />)}
                                {elmntBtn("معاينة كاشير", <PrintIcon />)}
                            </Fragment>
                        )}

                        {or.postput == "toPut" && !isHedden && (
                            <div className={clasCAB.wrapperCAB}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="large"
                                    className={buttonClassnamePrint}
                                    startIcon={<Update />}
                                    style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                    disabled={
                                        or.postput == "toPost"
                                            ? isSave === false ? true : false
                                            : loading.print || loading.save
                                    }
                                    onClick={() => clickUpdate()}
                                >
                                    {transForm("update")}
                                </Button>
                                {(loading.print || loading.save) && (
                                    <CircularProgress
                                        size={24}
                                        className={clasCAB.buttonProgressCAB}
                                    />
                                )}
                            </div>
                        )}
                        {or.postput === "toPost" ?
                            (
                                <div className={clasCAB.wrapperCAB}>
                                    {permistionInv.SaUp ? (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="large"
                                            style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                            className={buttonClassnameSave}
                                            disabled={
                                                loading.print ||
                                                loading.save ||
                                                (or.postput == "toPost" ? false : permistionInv.IPU)
                                            }
                                            onClick={() => toWhere("save", "e")}
                                            startIcon={<SaveIcon />}
                                        >
                                            {transForm("save-out-print")}
                                        </Button>
                                    ) : (
                                        <Fragment>
                                            {elmntBtn(transForm("save-out-print"), <SaveIcon />)}
                                        </Fragment>
                                    )}
                                    {(loading.print || loading.save) && (
                                        <CircularProgress
                                            size={24}
                                            className={clasCAB.buttonProgressCAB}
                                        />
                                    )}
                                </div>
                            ) : isOpenUpdate ? (
                                <div className={clasCAB.wrapperCAB}>
                                    {permistionInv.Up ? (
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            size="large"
                                            style={{ ...style.iconBtn, ...stElemnt.all.iconBtn }}
                                            className={buttonClassnameSave}
                                            disabled={
                                                loading.print ||
                                                loading.save ||
                                                (or.postput == "toPost" ? false : permistionInv.Up)
                                            }
                                            onClick={() => toWhere("save", "e")}
                                            startIcon={<SaveIcon />}
                                        >
                                            {transForm("save-out-print")}
                                        </Button>
                                    ) : (
                                        <Fragment>
                                            {elmntBtn(transForm("save-out-print"), <SaveIcon />)}
                                        </Fragment>
                                    )}
                                    {(loading.print || loading.save) && (
                                        <CircularProgress
                                            size={24}
                                            className={clasCAB.buttonProgressCAB}
                                        />
                                    )}
                                </div>
                            ) : null}
                    </Hidden>
                    {/* </div> */}
                </Toolbar>
            </AppBar>
        </React.Fragment>
    );
}